import './assets/base.scss';
import 'material-icons/iconfont/round.css';
import AppHeader from './components/AppHeader';
import { navigateTo } from './components/AppHeader/Link';
import AppMain from './components/AppMain';
import { cEl } from './util';
import { PATH_HOME } from './components/path';
import { setBaseURL } from './api';

function App() {
    const element = cEl('div');
    element.id = 'root';

    element.append(AppHeader(), AppMain());

    // 초기 메뉴 설정
    if (!window.location.hash) {
        navigateTo(PATH_HOME);
    }

    window.addEventListener('popstate', e => {
        navigateTo(window.location.hash, true);
    });

    return element;
}

setBaseURL().finally(() => {
    document.body.appendChild(App());
});
